var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        "justify-content": "center",
        "align-items": "center",
        height: "50vh",
      },
      on: {
        click: function ($event) {
          return _vm.UrlService.go({
            name: "landing",
            params: { ShopId: _vm.ShopId },
          })
        },
      },
    },
    [
      _c("img", { attrs: { src: "dist/assets/check-button.png" } }),
      _vm._v(" "),
      _c("h2", [_vm._v("Inscription confirmée !")]),
      _vm._v(" "),
      _c("a", { attrs: { href: _vm.ShopId + "/accueil" } }, [
        _vm._v("Continuer vers la page d'accueil"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }